const SVG = ({ fill = "none", stroke="#7F7F7F", width = "20", height = "19", viewBox = "0 0 20 19" }) => (
  <svg width={width} height={height} viewBox={viewBox} fill={fill} xmlns="http://www.w3.org/2000/svg">
    <path
      d="M1.77679 8.00112C1.77679 5.50112 3.23394 4.42969 5.41965 4.42969H12.7054C14.8911 4.42969 16.3482 5.50112 16.3482 8.00112V13.0011C16.3482 15.5011 14.8911 16.5725 12.7054 16.5725H5.41965"
      stroke={stroke}
      stroke-miterlimit="10"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path d="M13.1103 8.47656L10.5765 9.77596C9.06269 10.5004 9.06269 10.5004 7.54079 9.77596L5.01508 8.47656" stroke={stroke} stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round" />
    <path d="M0.966248 14.1445H5.01387" stroke={stroke} stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round" />
    <path d="M0.966248 10.9062H2.5853" stroke={stroke} stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round" />
  </svg>
);

export default SVG;
